import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Tooltip } from "antd";
import { useForm } from "react-hook-form";
import { labelClass, inputClass, formBtn2 } from "../Utils/CustomClasses";
import { validateEmail, validatePassword } from "../Utils/Validation";
import Error from "../Error/Error";
import {
  ChangePasswordAPI,
  ConfirmPasswordAPI,
  ForgotPasswordAPI,
} from "../../API/Api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { IconEye, IconEyeOff, IconInfoCircle } from "@tabler/icons-react";
export default function UpdatePassword({
  updatePassword,
  setUpdatePassword,
  type,
}) {
  const {
    reset,
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const [eyeIcon, setEyeIcon] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);

  const toggle = () => {
    setUpdatePassword(false);
    setShowOtpField(false);
    reset();
  };

  const onSubmit = async (data) => {
    try {
      let response;
      if (!showOtpField) {
        const payload = {
          email: data.email,
          oldPassword: data.oldPassword,
        };
        response = await ChangePasswordAPI(payload);
        if (response.status === 200) {
          toast.success(response?.data?.message);
          reset({ otp: "", newPassword: "" });
          setShowOtpField(true);
        } else {
          toast.error(response?.response?.data?.error);
        }
      } else {
        const Updatedpayload = {
          otp: Number(data.otp),
          newPassword: data.newPassword,
          email: UserDetails.email,
        };
        response = await ConfirmPasswordAPI(Updatedpayload);
        if (response.status === 200) {
          toast.success(response?.data?.message);
          toggle();
        } else {
          toast.error(response?.response?.data?.error);
        }
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  useEffect(() => {
    if (updatePassword) {
      setValue("email", UserDetails.email);
    }
  }, [updatePassword]);

  return (
    <Transition appear show={updatePassword} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={toggle}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-scroll">
          <div className="flex items-center justify-center min-h-full p-2 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                <Dialog.Title
                  as="h2"
                  className={`${
                    updatePassword ? "bg-base-color" : "bg-base-color-blue"
                  } w-full px-3 py-4 text-lg font-semibold leading-6 text-white font-tb`}
                >
                  {"Change Password"}
                </Dialog.Title>

                <div>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="p-4">
                      {!showOtpField ? (
                        <div className="grid grid-cols-1 gap-4">
                          <div>
                            <label className={labelClass}>
                              Email <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="email"
                              className={inputClass}
                              disabled={type === "change"}
                              {...register("email", {
                                required: true,
                                validate: validateEmail,
                              })}
                            />
                            {errors.email && (
                              <Error title={errors.email.message} />
                            )}
                          </div>

                          <div>
                            <div className="flex items-center gap-2">
                              <label className={labelClass}>
                                Old Password{" "}
                                <span className="text-red-500">*</span>
                              </label>
                              <span className="">
                                <Tooltip
                                  title={
                                    <>
                                      <div>
                                        Password must contain at least first
                                        letter uppercase one special character
                                        and one number
                                      </div>
                                    </>
                                  }
                                  placement="right"
                                  color="#032037"
                                >
                                  <IconInfoCircle stroke={1.5} size="23" color="#000" />
                                </Tooltip>
                              </span>
                            </div>
                            <div className="relative flex items-center mt-1">
                              <input
                                className={inputClass}
                                type={!eyeIcon ? "password" : "test"}
                                {...register("oldPassword", {
                                  required: "Password is required",
                                })}
                              />
                              <span
                                className="absolute z-10 right-2 "
                                onClick={() => setEyeIcon(!eyeIcon)}
                              >
                                {eyeIcon ? (
                                  <IconEye stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                ) : (
                                  <IconEyeOff stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                )}
                              </span>
                            </div>
                            {errors.oldPassword && (
                              <Error title={errors.oldPassword.message} />
                            )}
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-6">
                          <div>
                            <label className={labelClass}>
                              Enter OTP <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              className={inputClass}
                              {...register("otp", {
                                required: "OTP is required",
                              })}
                            />
                            {errors.otp && <Error title={errors.otp.message} />}
                          </div>
                          <div>
                            <label className={labelClass}>
                              New Password{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <div className="relative flex items-center mt-1">
                              <input
                                type={!eyeIcon ? "password" : "test"}
                                className={inputClass}
                                {...register("newPassword", {
                                  required: "New password is required",
                                  validate: validatePassword,
                                })}
                              />
                              <span
                                className="absolute z-10 right-2 "
                                onClick={() => setEyeIcon(!eyeIcon)}
                              >
                                {eyeIcon ? (
                                  <IconEye stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                ) : (
                                  <IconEyeOff stroke={1.5} size={24} color="#000" className="cursor-pointer" />
                                )}
                              </span>
                            </div>
                            {errors.newPassword && (
                              <Error title={errors.newPassword.message} />
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                      <button
                        type="submit"
                        className={`${
                          updatePassword
                            ? "bg-base-color"
                            : "bg-base-color-blue"
                        } px-4 py-2 text-white font-bold rounded-lg`}
                      >
                        {!showOtpField ? "Send OTP" : "Verify OTP"}
                      </button>

                      <button
                        type="button"
                        className={`${
                          updatePassword ? "bg-base-color text-white" : formBtn2
                        } px-4 py-2 font-bold rounded-lg`}
                        onClick={toggle}
                      >
                        Close
                      </button>
                    </footer>
                  </form>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
